/* eslint-disable */
require('./1-B')
require('./1-L')
require('./10-B')
require('./10-L')
require('./2-B')
require('./2-L')
require('./3-B')
require('./3-L')
require('./4-B')
require('./4-L')
require('./5-B')
require('./5-L')
require('./6-B')
require('./6-L')
require('./7-B')
require('./7-L')
require('./8-B')
require('./8-L')
require('./9-B')
require('./9-L')
